import GoyoloPartner from '@/components/desktop/GoyoloPartner/desktop';
import React from 'react';

const SectionPartner = () => (
  <GoyoloPartner isHideTitle />
);

export default SectionPartner;
